import { useState } from 'react';
import { ArrowDownLeft } from 'lucide-react';
import { toast } from 'sonner';
import { demoteMitToAzione } from '../../lib/api';

/**
 * Pulsante "Retrocedi MIT → Azione".
 * Simmetrico a PromoteToMitButton. Click diretto: retrocede subito
 * mantenendo la data (l'azione resta fissata al giorno). Popover NON
 * necessario perché la settimana viene derivata automaticamente lato backend.
 *
 * Props:
 *  - mitId: id della MIT da retrocedere
 *  - onDemoted(payload): callback dopo demote riuscito (`{ azione, deleted_mit_id }`)
 *  - testid: data-testid del pulsante
 */
export default function DemoteToAzioneButton({ mitId, onDemoted, testid }) {
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    try {
      const res = await demoteMitToAzione(mitId, { mantieni_data: true });
      toast.success('MIT retrocessa ad azione');
      if (onDemoted) onDemoted(res);
    } catch (err) {
      const msg = err?.response?.data?.detail || 'Errore retrocessione';
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={submit}
      disabled={busy}
      title="Retrocedi ad azione (mantiene la data)"
      aria-label="Retrocedi MIT ad azione"
      className="p-1 text-mute hover:text-accent disabled:opacity-40 shrink-0"
      data-testid={testid || `demote-azione-btn-${mitId}`}
    >
      <ArrowDownLeft size={14} strokeWidth={1.5} />
    </button>
  );
}
